module.exports = __webpack_public_path__ + "img/240.dust.b2aec590.svg";